import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  IconButton,
  Grid,
  TextField
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import './style.css'
import '../../App.css'
import moment from 'moment'
import { AddConsultantCost, EditConsultantCost, DeletetConsultantCost } from './usersAction';
import NumberFormat from 'react-number-format';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import locale from 'antd/es/date-picker/locale/de_DE';
import numeral from 'numeral';
import 'numeral/locales/de'

numeral.locale('de');

const dateFormat = 'MM/YYYY';

class Costs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isDeleteContactDialogOpen: false,
      isCostEditDialogOpen: false,
      isCostAddDialogOpen: false,
      yearMothField: '',
      costField: '',
      isCostFieldEmpty: false,
      isMonthFieldEmpty: false,
      editMode: false,
      userCOnsultantCost: [],
      costID: ''
    }
    this.textInput = React.createRef();

  }
  focusTextInput = () => {
    this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { user_consultant_costs } = this.props
    this.setState({ userCOnsultantCost: user_consultant_costs })
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { userCOnsultantCost } = this.state
    if (nextProps.user_consultant_costs !== userCOnsultantCost) {
      this.setState({ userCOnsultantCost: nextProps.user_consultant_costs })
    }
  }

  createCost = () => {
    const { AddConsultantCost, userId, EditConsultantCost } = this.props
    const dataObj = this.state
    if (dataObj.costField !== '' && dataObj.yearMothField !== '') {
      if (dataObj.editMode) {
        EditConsultantCost(userId, dataObj)
        this.setState({ isCostEditDialogOpen: false, costField: '', yearMothField: '', editMode: false })
      } else {
        AddConsultantCost(userId, dataObj)
        this.setState({ isCostEditDialogOpen: false, costField: '', yearMothField: '' })
      }
    } else {
      if (dataObj.costField === '' && dataObj.yearMothField === '')
        this.setState({ isCostFieldEmpty: true, isMonthFieldEmpty: true })
      if (dataObj.costField === '' && dataObj.yearMothField !== '')
        this.setState({ isCostFieldEmpty: true, })
      if (dataObj.costField !== '' && dataObj.yearMothField === '')
        this.setState({ isMonthFieldEmpty: true })
    }
  }

  deleteCost = () => {
    const { DeletetConsultantCost, userId } = this.props
    DeletetConsultantCost(userId, this.state.costID)
    this.setState({ isDeleteContactDialogOpen: false })
  }

  render() {
    const { costField, isMonthFieldEmpty, isDeleteContactDialogOpen, userCOnsultantCost, isCostEditDialogOpen, yearMothField, isCostFieldEmpty, editMode } = this.state
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    return (
      <div
        className={` capacityTable tableActivity tableStyle ${Number(access_rights.users) === 1 ? "disableALlFields" : ""}`}
      >
        <Grid container spacing={1}>
          <div className="action-top-btn">
            <Button variant="outlined" color="primary" onClick={() => {
              setTimeout(() => {
                this.focusTextInput()
              }, 100)
              this.setState({ isCostEditDialogOpen: true })
            }}  >
              Kosten hinzufügen
            </Button>
          </div>
          <TableContainer className="width-auto">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell >Aktion</TableCell>
                  <TableCell >Monat/Jahr</TableCell>
                  <TableCell style={{ textAlign: "right" }} >Tagessatz</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userCOnsultantCost &&
                  userCOnsultantCost.map(cost => (
                    <TableRow key={cost.id}>
                      <TableCell >
                        <IconButton aria-label="edit"
                          onClick={() => {
                            setTimeout(() => {
                              this.focusTextInput()
                            }, 100)
                            this.setState({ isCostEditDialogOpen: true, editMode: true, costID: cost.id, costField: cost.daily_rate, yearMothField: cost.month !== null ? moment(cost.month).format("MM.YYYY") : '' })
                          }
                          }
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => this.setState({ isDeleteContactDialogOpen: true, costID: cost.id })} aria-label="delete">
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell >{cost.month !== null ? moment(cost.month).format("MM/YYYY") : ''}</TableCell>
                      <TableCell style={{ textAlign: "left" }}>
                        <NumberFormat
                          customInput={TextField}
                          size="small"
                          value={Number(cost.daily_rate)}
                          className="rightToLeft showData"
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale="2"
                          fixedDecimalScale={true}
                        /></TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Dialog open={isCostEditDialogOpen} maxWidth="sm">
          <DialogTitle id="form-dialog-title">Kosten bearbeiten</DialogTitle>
          <DialogContent className="p-60">
            <Grid container spacing={1} justify="center">
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Monat/Jahr
              </Grid>
              <Grid item xs={10}>
                <DatePicker
                  className={isMonthFieldEmpty ? "errorClass" : ''}
                  locale={locale}
                  value={yearMothField === "" ? '' : moment(yearMothField, dateFormat)}
                  format={dateFormat}
                  placeholder="MM/YYYY"
                  bordered={false}
                  picker="month"
                  onChange={(e) => {
                    if (e !== null) {
                      let date = moment(e._d).format("MM.YYYY");
                      this.setState({ yearMothField: date, isMonthFieldEmpty: false })
                    } else {
                      this.setState({ yearMothField: '', isMonthFieldEmpty: false })
                    }
                  }}
                />
                <br />
                {isMonthFieldEmpty &&
                  <div className="errorSpan">
                    <span>
                      Monat/Jahr darf nicht leer sein
                    </span>
                  </div>
                }
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Tagessatz
              </Grid>
              <Grid item xs={10}>
                <NumberFormat
                  inputProps={{
                    maxLength: 10
                  }}
                  customInput={TextField}
                  helperText={isCostFieldEmpty ? "Tagessatz darf nicht leer sein" : ''} error={isCostFieldEmpty ? true : false}
                  inputRef={this.textInput}
                  fullWidth size="small"
                  value={costField !== "" ? Number(costField) : ''}
                  variant="outlined"
                  className="rightToLeft"
                  thousandSeparator='.'
                  decimalSeparator=","
                  decimalScale="2"
                  allowNegative={false}
                  onChange={(e) => this.setState({ costField: numeral(e.target.value).value(), isCostFieldEmpty: false })}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            {editMode ?
              <Button variant="outlined" className="m-10" onClick={this.createCost} color="primary">
                Speichern
            </Button> :
              <Button variant="outlined" className="m-10" onClick={this.createCost} color="primary">
                Hinzufügen
              </Button>
            }
            <Button variant="outlined" className="m-10" onClick={() => this.setState({ isCostEditDialogOpen: false, editMode: false, isMonthFieldEmpty: false, isCostFieldEmpty: false, yearMothField: '', costField: '' })} color="secondary">
              Abbrechen
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={isDeleteContactDialogOpen}
        >
          <DialogTitle>Kosten löschen</DialogTitle>
          <DialogContent>
            <DialogContentText >
              Sind Sie sicher?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.deleteCost} size="small" variant="outlined" color="primary" autoFocus>
              Bestätigen
              </Button>
            <Button onClick={() => this.setState({ isDeleteContactDialogOpen: false })} size="small" variant="outlined" color="secondary">
              Abbrechen
              </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}



const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    AddConsultantCost: (id, dataObj) => dispatch(AddConsultantCost(id, dataObj)),
    EditConsultantCost: (id, dataObj) => dispatch(EditConsultantCost(id, dataObj)),
    DeletetConsultantCost: (userId, id) => dispatch(DeletetConsultantCost(userId, id)),
  }
}


export default connect(null, mapDispatchToProps)(Costs)